
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
import 'jquery.easing';

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
    keyName: 'metaInfo'
})

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

import {
    Form,
    HasError,
    AlertError,
    AlertErrors, 
    AlertSuccess
} from 'vform';

window.vForm = Form;

Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);
Vue.component(AlertErrors.name, AlertErrors);
Vue.component(AlertSuccess.name, AlertSuccess);

import swal from 'sweetalert2';
window.Swal = swal;

const Toast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000
});

window.toast = Toast;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('int-menu', require('./components/Internal/MenuInt.vue').default);
Vue.component('blog-home', require('./components/External/Blog/BlogHome.vue').default);
Vue.component('blog-post', require('./components/External/Blog/BlogPost.vue').default);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('procura-card', require('./components/External/Blog/ProcuraCard.vue').default);
Vue.component('categorias-widget', require('./components/External/Blog/CategoriasWidget.vue').default);
Vue.component('tags-widget', require('./components/External/Blog/TagsWidget.vue').default);
Vue.component('posts-from-category', require('./components/External/Blog/BlogPostsFromCategory.vue').default);
Vue.component('posts-from-tag', require('./components/External/Blog/BlogPostsFromTag.vue').default);
Vue.component('reactions', require('./components/External/Blog/Reactions.vue').default);
Vue.component('comentaries', require('./components/External/Blog/BlogComentaries.vue').default);
Vue.component('loading-component', require('./components/External/Loading.vue').default);


import VueProgressBar from 'vue-progressbar'
const options = {
	color: '#28a745',
	failedColor: '#dc3545',
	thickness: '5px',
	transition: {
	  speed: '0.2s',
	  opacity: '0.6s',
	  termination: 300
	},
	autoRevert: true,
	location: 'top',
	inverse: false
  }
  
  Vue.use(VueProgressBar, options)

window.Fire = new Vue();

const app = new Vue({
    el: '#app',
    components: {},
});

